<template>
    <div>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>

        <!-- テーブル -->
        <template>
            <v-pagination
                v-model="indexInfo.page"
                :length="indexInfo.pageCount"
            ></v-pagination>
            <v-data-table
                :items="items"
                :page.sync="indexInfo.page"
                :items-per-page="indexInfo.itemsPerPage"
                @page-count="indexInfo.pageCount = $event"
                disable-sort
                hide-default-headers
                hide-default-footer
                class="mx-3"
            >
                <template v-slot:body="props">
                    <tr v-for="(item, index) in props.items" :key="index">
                        <td class="item-td" align="center" width="5%;">
                        </td>
                        <td class="item-td" align="left" width="75%;">
                            <template v-if="item.is_official">
                                <badge-component tile content="公式" color="blue">
                                    {{ item.template_name }}
                                </badge-component>
                            </template>
                            <template v-else>
                                {{ item.template_name }}
                            </template>
                        </td>
                        <td align="center">
                            <v-btn color="blue-grey" class="white--text" width="10%;" @click="overViewLink(item.object_id)">概要</v-btn>
                        </td>
                        <td align="center">
                            <v-btn color="red" class="white--text" width="10%;" @click="dialog(item)">使用する</v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </template>

    <template>
        <v-dialog v-model="handleDialog" width="700" class="common-dialog">
            <v-card color="#F4FEFB">
                <v-card-title class="justify-center text-h4">
                    {{ templatName }}を使用します。よろしいですか？
                </v-card-title>

                <v-divider></v-divider>

                <v-card-actions class="justify-center grey lighten-4 pb-6">
                    <v-btn min-width="150px" class="white--text" color="red" large @click="use(uid)">
                        はい
                    </v-btn>
                    <v-btn min-width="150px" class="white--text" color="blue-grey" large @click="handleDialog = false">
                        キャンセル
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>
    </div>
</template>

<script>
    export default {
        props: ['user', 'items'],
        data() {
            return {
                message: {
                    success: false,
                    text: '',
                },
                sending: false,
                indexInfo: {
                    // ページ数
                    page: 1,
                    // 最大ページ数
                    pageCount: 0,
                    // 1ページあたりの項目数
                    itemsPerPage: 10,
                },
                handleDialog: false,
                templatName: '',
            };
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        methods: {
            dialog (item) {
                this.handleDialog = true;
                this.templatName = item.template_name;
                this.uid = item.object_id;
            },
            use: async function (uid) {
                this.sending = true;
                try {
                    if (this.uid != null && this.uid.length) {
                        window.location = uid + '/confirm';
                    }
                }
                finally {
                    this.sending = false;
                }
            },
            // 契約概要画面へ
            overViewLink(uid) {
                window.location = '/documents/document-management/multiple-send-template/' + uid + '/over-view';
            },
        },
    };
</script>
<style scoped>
    /* table */
    .v-btn:not(.v-btn--round).v-size--default {
        margin: 2px 0;
    }
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
    }
</style>